export default __webpack_public_path__ + "static/media/pictogramBeaconLocation64.4f97b282.svg";